/* global modForm */
import { initExtraQuestionBlock } from '../../../helpers';

/**
 * Init click to proceed for radio buttons in the form
 * @param {Array} excludedOptions - array of radio button names to exclude from click to proceed. Example: ['DoorProjectScope']
 */
export function initClickToProceed(excludedOptions = []) {
	const $form = modForm.opts.form;

	if (modForm.opts.extraQuestionBlock) {
		modForm.opts.extraQuestionInputs.forEach(($input) => {
			if ($input) {
				$input.removeAttribute('data-required');
			}
		});
	}

	$form.querySelectorAll('input[type="radio"]').forEach(function($radio) {
		if (excludedOptions.includes($radio.name)) {
			return;
		}

		$radio.addEventListener('click', function(e) {
			e.stopImmediatePropagation();
			if (modForm.radioButtonClickedByMouse) {
				initExtraQuestionBlock(this);
				modForm.radioButtonClickedByMouse = false;
			}
		});

		if (modForm.opts.extraQuestionBlock) {
			$radio.addEventListener('keypress', function(e) {
				e.stopImmediatePropagation();
				if (e.keyCode === 13 || e.key === 'Enter') {
					initExtraQuestionBlock(this);
				}
			});
		}
	});
}
